/* KAMOK_ACCESSIBLE_CATALOG_V1: native details; Escape/outside click; no hijacking links. */
(()=>{if(window.__kmCatalogInit)return;window.__kmCatalogInit=true;
  const details=()=>[...document.querySelectorAll('[data-km-catalog]')];
  document.addEventListener('keydown',event=>{
    if(event.key!=='Escape')return;
    for(const el of details().filter(x=>x.open)){el.open=false;el.querySelector(':scope > summary')?.focus()}
  });
  document.addEventListener('pointerdown',event=>{
    for(const el of details().filter(x=>x.open)){if(!el.contains(event.target))el.open=false}
  });
  document.addEventListener('toggle',event=>{
    const el=event.target;if(!el.matches?.('[data-km-catalog]')||!el.open)return;
    for(const other of details())if(other!==el)other.open=false;
  },true);
})();